import React from "react";
import "./entity.css";
import {Table,TableBody,TableContainer,TableHead,TableRow,Paper,TableCell,MenuItem,Menu,Skeleton,} from "@mui/material";
import StyledTableCell from "../../Tabletheme/Customtableheader";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const EntityTable = ({
    loader,
    anchorEl,
    sortField,
    sortOrder,
    handleSort,
    getmaintaindata,
    handleEditClick,
    selectedRowIndex,
    handleClickEditDelete,
}) => {
  return (
    <>
    <TableContainer sx={{ marginTop: 5 }} component={Paper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell onClick={() => handleSort("entity_name")}>
                  Name
                  {sortField === "entity_name" && (
                    <>
                      {sortOrder === "asc" ? (
                        <img
                          src="assets/Images/Ascending.svg"
                          alt="Ascending"
                          style={{ width: "5%", marginLeft: "5px" }}
                        />
                      ) : (
                        <img
                          src="assets/Images/descending.svg"
                          alt="Descending"
                          style={{ width: "5%", marginLeft: "5px" }}
                        />
                      )}
                    </>
                  )}
                </StyledTableCell>
                <StyledTableCell>Entity Type</StyledTableCell>
                <StyledTableCell>Sender Code</StyledTableCell>
                <StyledTableCell>Receiver Code</StyledTableCell>
                <StyledTableCell>Organisation Code</StyledTableCell>
                <StyledTableCell>End Point Address</StyledTableCell>
                <StyledTableCell>Endpoint Folder</StyledTableCell>
                <StyledTableCell>Endpoint Port</StyledTableCell>
                <StyledTableCell>Endpoint Type</StyledTableCell>
                <StyledTableCell />
              </TableRow>
            </TableHead>
            {loader ? (
              <>
                {new Array(7).fill(3).map((element, index) => {
                  return (
                    <TableRow key={index}>
                      {new Array(9).fill(1).map((element, index) => {
                        return (
                          <TableCell align="center" key={index}>
                            <Skeleton
                              variant="rounded"
                              width={"100%"}
                              height={60}
                            />
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </>
            ) : (
              <>
                {getmaintaindata.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      <p>No Data Found</p>
                    </TableCell>
                  </TableRow>
                ) : (
                  <TableBody>
                    {getmaintaindata.map((maintain, index) => (
                      <TableRow key={index}>
                        <TableCell>{maintain.entity_name}</TableCell>
                        <TableCell>{maintain.entity_type_name}</TableCell>
                        <TableCell>{maintain.entity_sender_code}</TableCell>
                        <TableCell>{maintain.entity_receiver_code}</TableCell>
                        <TableCell>{maintain.entity_org_code}</TableCell>
                        <TableCell>
                          {maintain.recipient_endpoint_address}
                        </TableCell>
                        <TableCell>
                          {maintain.recipient_endpoint_folder}
                        </TableCell>
                        <TableCell>
                          {maintain.recipient_endpoint_port}
                        </TableCell>
                        <TableCell>
                          {maintain.endpoint_type_name}
                        </TableCell>
                        <TableCell>
                          <div style={{ textAlign: "center" }}>
                            <MoreVertIcon
                              onClick={(event) => handleEditClick(event, index)}
                              id="basic-button"
                              aria-controls={
                                Boolean(anchorEl)
                                  ? `basic-menu-${index}`
                                  : undefined
                              }
                              aria-haspopup="true"
                              aria-expanded={
                                Boolean(anchorEl) ? "true" : undefined
                              }
                            />

                            <Menu
                              id={`basic-menu-${index}`}
                              anchorEl={anchorEl}
                              open={
                                selectedRowIndex !== null &&
                                selectedRowIndex === index
                              }
                              onClose={handleClickEditDelete}
                              MenuListProps={{
                                "aria-labelledby": `basic-button-${index}`,
                              }}
                            >
                              <MenuItem
                                onClick={(event) => {
                                  handleClickEditDelete(event, maintain, index);
                                }}
                              >
                                Edit
                              </MenuItem>
                              <MenuItem
                                onClick={(event) => {
                                  handleClickEditDelete(event, maintain, index);
                                }}
                              >
                                Delete
                              </MenuItem>
                            </Menu>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>
    </>
  )
};

export default EntityTable;
